import { createAction, props } from '@ngrx/store';
import { ServiceRequestCompletedState } from './service-request-completed.state';

/** StateDetailsActions */
const ACTION_SET = '[ServiceRequestCompleted] set';
const ACTION_UPDATE = '[ServiceRequestCompleted] update';
const ACTION_RESET = '[ServiceRequestCompleted] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setStateServiceRequestCompleted = createAction(ACTION_SET, props<ServiceRequestCompletedState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateStateServiceRequestCompleted = createAction(
  ACTION_UPDATE,
  props<Partial<ServiceRequestCompletedState>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetStateServiceRequestCompleted = createAction(ACTION_RESET);
